function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiMenu from "@mui/material/Menu";
const Menu = ({
  children,
  id = "menu-default-id",
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiMenu, _extends({
    id: id
  }, rest), children);
};
Menu.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  id: PropTypes.string,
  menuList: PropTypes.array,
  isHeader: PropTypes.bool
};
export default Menu;